import { httpService } from '../..';
import { IEntityWithMessages } from '../../services/HttpService';
import { IApiExecuteRespone } from '../apiInterfaces';
import { ApiUrls } from '../ApiUrls';
import { IDpNewsFeedTag } from '../lookups';
import { IDpNewsFeedPost } from './dpNewsFeedInterfaces';

export async function addDpNewsFeedTag(tag: string): Promise<IApiExecuteRespone<IDpNewsFeedTag>> {
  const response: IApiExecuteRespone<IDpNewsFeedTag> = { requestFailed: false };
  try {
    const apiResponse = await httpService.post(ApiUrls.dpNewsFeedTag(), { tag });
    response.value = await apiResponse.json();
  } catch (e) {
    response.requestFailed = true;
    response.exception = e;
  }

  return response;
}

export async function checkDpPostAccess(postId: number): Promise<IApiExecuteRespone<string[]>> {
  const response: IApiExecuteRespone<string[]> = { requestFailed: false };
  try {
    const apiResponse = await httpService.get(ApiUrls.dpNewsFeedPostCheckAccess(postId));
    response.value = await apiResponse.json();
  } catch (e) {
    response.requestFailed = true;
    response.exception = e;
  }

  return response;
}

export async function deleteDpPostAccess(dpNewsFeedPostAccessId: number): Promise<IApiExecuteRespone<IDpNewsFeedPost>> {
  const response: IApiExecuteRespone<IDpNewsFeedPost> = { requestFailed: false };
  try {
    const apiResponse = await httpService.delete(ApiUrls.dpNewsFeedPostAccess(dpNewsFeedPostAccessId));
    response.value = await apiResponse.json();
  } catch (e) {
    response.requestFailed = true;
    response.exception = e;
  }

  return response;
}

export async function fetchDpNewsFeedPost(postId: number): Promise<IApiExecuteRespone<IDpNewsFeedPost>> {
  const response: IApiExecuteRespone<IDpNewsFeedPost> = { requestFailed: false };
  try {
    const apiResponse = await httpService.get(ApiUrls.dpNewsFeedPosts(postId));
    response.value = await apiResponse.json();
  } catch (e) {
    response.requestFailed = true;
    response.exception = e;
  }

  return response;
}

export async function fetchDpNewsFeedPosts(): Promise<IApiExecuteRespone<IDpNewsFeedPost[]>> {
  const response: IApiExecuteRespone<IDpNewsFeedPost[]> = { requestFailed: false };
  try {
    const apiResponse = await httpService.get(ApiUrls.dpNewsFeedPosts());
    response.value = await apiResponse.json();
  } catch (e) {
    response.requestFailed = true;
    response.exception = e;
  }

  return response;
}

export async function updateDpNewsFeedPost(
  post: IDpNewsFeedPost
): Promise<IApiExecuteRespone<IEntityWithMessages<IDpNewsFeedPost>>> {
  const response: IApiExecuteRespone<IEntityWithMessages<IDpNewsFeedPost>> = { requestFailed: false };
  try {
    const apiResponse = await httpService.post(ApiUrls.dpNewsFeedPosts(), post);
    response.value = await apiResponse.json();
  } catch (e) {
    response.requestFailed = true;
    response.exception = e;
  }

  return response;
}
